export const WORK_AREA_TYPE_BY_SPECIALIZATION_TYPE: any = {
  tech: 'Engineering',
  'non-tech': 'Non-engineering',
};

export enum WORK_AREA_TYPE {
  ENGINEERING = 'Engineering',
  NON_ENGINEERING = 'Non-engineering',
}
